define([
	"dojo/_base/declare",
	"csi/action/AggregateController"
], function(declare,AggregateController) {

	return declare(AggregateController, {
		// Boolean: indicates that action works on view refNode
		bRefNode: true
	});
});